export const SendMessageOptions = {
  AllAgencies: "All Agencies",
  // OnlyEmployees: "Only Employees",
  SpecificAgencies: "Specific Agencies",
  SpecificParentAgency: "Under Specific Agency",
  AgenciesWhoHasSpecificRatios: "Agencies with specific ratio",
  AgenciesWithRatioLargerThan: "Agencies with Ratio Larger than",
  AgenciesWithRatioSmallerThan: "Agencies with Ratio Smaller than",
  SpecificAgencyList: "Specific Agency List",
  TopAgencies: "Top Agencies",
  AgenciesWithNoInsurances: "Agencies With No Insurances",
  AgenciesWhoStoppedWorkingLast7Days: "Who Stopped Working Latest 7 Days",
  AgenciesWhoStoppedWorkingLast30Days: "Who Stopped Working Latest 30 Days",
  AgenciesWhoStoppedWorkingLast60Days: "Who Stopped Working Latest 60 Days",
};

export const SendMessageOptionsArray = [
  SendMessageOptions.AllAgencies,
  SendMessageOptions.SpecificAgencies,
  SendMessageOptions.SpecificParentAgency,
  SendMessageOptions.AgenciesWhoHasSpecificRatios,
  SendMessageOptions.AgenciesWithRatioLargerThan,
  SendMessageOptions.AgenciesWithRatioSmallerThan,
  SendMessageOptions.SpecificAgencyList,
  SendMessageOptions.TopAgencies,
  SendMessageOptions.AgenciesWithNoInsurances,
  SendMessageOptions.AgenciesWhoStoppedWorkingLast7Days,
  SendMessageOptions.AgenciesWhoStoppedWorkingLast30Days,
  SendMessageOptions.AgenciesWhoStoppedWorkingLast60Days,
];
